import React from 'react';
import classNames from 'classnames';
import './SidebarLayoutContent.scss';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const SidebarLayoutContent: React.FC<Props> = ({ className, children, ...rest }) => {
  return (
    <div className={classNames('SidebarLayoutContent', className)} {...rest}>
      {children}
    </div>
  );
};
